import React, { useState, useEffect } from 'react';
import { Avatar, Fab, Tooltip, Zoom } from '@mui/material';
import axios from "axios";
import utils from "../../utils";
import { motion } from 'framer-motion';

const WhatsappButton = () => {
  const [op, setOp] = useState(false);
  const whatsappUrl = "https://wa.me/390458201309";
  const whatsappOpUrl = "https://web.whatsapp.com/";

  useEffect(() => {
    loadMe();
  }, []);

  const loadMe = async () => {
    try {
      const res = await axios.get("/api/me", {
        headers: utils.getAuthHeaders(),
        validateStatus: () => true,
      });
      if (res.status === 200) {
        const { success, me } = res.data;
        if (success && me.op) {
          setOp(true);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const openWhatsAppPopup = () => {
    window.open(op ? whatsappOpUrl : whatsappUrl, '_blank');
  };

  return (
    <Tooltip title="WhatsApp" placement="left" TransitionComponent={Zoom}>
      <Fab
        size="small"
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 10,
          zIndex: 1000,
          padding: 0,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'rgba(0, 127, 255, 0.2)',
            transform: 'scale(1.05)',
          },
          transition: 'all 0.3s ease',
        }}
        onClick={openWhatsAppPopup}
        aria-label="WhatsApp"
      >
        <motion.div
          whileHover={{ scale: [1, 1.1, 1] }}
          transition={{
            duration: 0.3,
            ease: "easeInOut",
            repeat: 3, // Ripete l'animazione 3 volte
            repeatDelay: 0.1 // Piccolo ritardo tra le ripetizioni
          }}
        >
          <Avatar
            alt="WhatsApp"
            src="/img/whats.png"

          />
        </motion.div>
      </Fab>
    </Tooltip>

  );
};

export default WhatsappButton;
